import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
      {categories.map((cat) => (
        <Link
          key={cat.key}
          to={`/category/${cat.key}`}
          className="group flex flex-col items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
        >
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-16 md:w-16">
            <i className={`${cat.icon} text-2xl md:text-3xl`} />
          </span>
          <span className="font-heading text-base font-semibold text-foreground-950">{cat.name}</span>
          <span className="line-clamp-2 text-xs leading-relaxed text-foreground-500">{cat.desc}</span>
        </Link>
      ))}
    </div>
  );
}